import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { StakeholderTypeGroup } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useLocale } from '../use-locale.hook';

export const useStakeholderInfo = () => {
  const { locale } = useLocale();
  const { mutate: downloadStakeholderInfo, isPending } = useAppMutation(
    [QueryKey.STAKEHOLDERS_DOWNLOAD_INFO],
    {
      mutationFn: ({
        companyId,
        typeGroup,
      }: {
        companyId: string;
        typeGroup: StakeholderTypeGroup;
      }) =>
        ApiService.downloadFile(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'stakeholders', typeGroup, 'xlsx'],
          },
          { locale },
        ),
    },
  );
  return { downloadStakeholderInfo, isPending };
};
